export const STUDIO_AND_APARTMENT_FEATURES = [
  3000, 3016, 3018, 3011, 3012, 3013, 3019, 3027, 3009, 3008, 4001, 3002, 3100,
  3010, 3028, 3007, 5003, 3015
];

export const ROOM_SHARED_AND_RESIDENCE_FEATURES = [
  4003, 4005, 6000, 6001, 4000, 4004, 4102, 4103, 4006, 5003, 4001, 3002, 4002,
  4101, 3019
];
